import styled from "styled-components";
import { registrationScrollBodyStyles } from "../RegistrationLayout/registrationScrollBodyStyles";
import { registrationFormStyles } from "../RegistrationLayout/registrationFormStyles";
import { registrationCardHeaderStyles } from "../RegistrationLayout/registrationFlowLayout";
import {
  REGISTRATION_FONT_BODY,
  REGISTRATION_FONT_DISPLAY,
} from "../RegistrationLayout/registrationTheme";

const RegistrationSetupWrapper = styled.div`
  --radius-sm: 8px;

  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  background: transparent;
  font-family: ${REGISTRATION_FONT_BODY};

  .scroll-body {
    ${registrationScrollBodyStyles}
  }

  .registration-card-header {
    ${registrationCardHeaderStyles}
  }

  .content-card-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding: 32px 20px calc(28px + env(safe-area-inset-bottom, 0px));
    box-sizing: border-box;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }

    @media (min-width: 600px) {
      padding: 32px 32px calc(36px + env(safe-area-inset-bottom, 0px));
    }
  }

  ${registrationFormStyles}

  .stripe-card-element-wrap {
    display: block;
    width: 100%;
    min-height: 48px;
    padding: 12px 16px;
    border: 1.5px solid rgba(30, 42, 53, 0.15);
    border-radius: 10px;
    background-color: #ffffff;
    box-sizing: border-box;
    position: relative;
    z-index: 1;
  }

  .stripe-card-element-wrap .StripeElement {
    display: block;
    width: 100%;
    min-height: 24px;
  }

  .stripe-card-element-wrap .StripeElement iframe {
    display: block;
    width: 100% !important;
    min-height: 24px;
    pointer-events: auto;
  }

  .stripe-card-element-wrap:focus-within {
    border-color: #aece38;
    box-shadow: 0 0 0 3px rgba(174, 206, 56, 0.18);
  }

  .stripe-card-element-loading {
    font-size: 14px;
    color: #6e7d8f;
    line-height: 24px;
  }

  .stripe-card-element-placeholder {
    cursor: text;
    color: #9aa8b8;
    letter-spacing: 2px;
  }

  .cc-visual {
    background: linear-gradient(135deg, #2d3f52 0%, #3d5166 100%);
    border-radius: 14px;
    padding: 22px 24px;
    color: #fff;
    margin-bottom: 24px;
    position: relative;
    overflow: hidden;
  }

  .cc-visual::before {
    content: "";
    position: absolute;
    top: -30px;
    right: -30px;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.05);
  }

  .cc-visual::after {
    content: "";
    position: absolute;
    bottom: -20px;
    left: -20px;
    width: 90px;
    height: 90px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.04);
  }

  .cc-chip {
    width: 32px;
    height: 24px;
    border-radius: 4px;
    background: #e8b84a;
    margin-bottom: 18px;
    opacity: 0.9;
  }

  .cc-number {
    font-size: 17px;
    letter-spacing: 3px;
    font-weight: 500;
    margin-bottom: 16px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .cc-meta {
    display: flex;
    gap: 32px;
    font-size: 11px;
  }

  .cc-meta-label {
    opacity: 0.55;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    font-size: 10px;
    margin-bottom: 3px;
  }

  .cc-meta-val {
    font-size: 13px;
    font-weight: 600;
  }

  .cc-brand {
    position: absolute;
    bottom: 22px;
    right: 24px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1px;
    opacity: 0.5;
  }

  .policy-link {
    background: none;
    border: none;
    padding: 0;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
    font-size: inherit;
    font-weight: 600;
    color: #8aab15;
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  .scroll-body-centered {
    justify-content: center;
  }

  .content-card-centered {
    text-align: center;
  }

  .discovery-checking {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 36px 20px;
    text-align: center;
  }

  .discovery-spinner-wrap {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: rgba(174, 206, 56, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .discovery-spinner {
    width: 72px;
    height: 72px;
    border: 3px solid rgba(174, 206, 56, 0.2);
    border-top-color: #aece38;
    border-radius: 50%;
    animation: registration-spin 0.9s linear infinite;
    position: absolute;
  }

  @keyframes registration-spin {
    to {
      transform: rotate(360deg);
    }
  }

  .discovery-spinner-icon {
    font-size: 26px;
    position: relative;
    z-index: 1;
  }

  .discovery-checking-title {
    font-family: ${REGISTRATION_FONT_DISPLAY};
    font-weight: 500;
    font-size: 20px;
    color: #5a6b80;
    line-height: 1.2;
  }

  .discovery-checking-sub {
    font-size: 13px;
    color: #6e7d8f;
    max-width: 280px;
    line-height: 1.55;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .discovery-steps {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    max-width: 300px;
    margin-top: 8px;
  }

  .discovery-step {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 13px;
    color: #6e7d8f;
    font-family: ${REGISTRATION_FONT_BODY};
    text-align: left;
  }

  .discovery-step.done {
    color: #8aab15;
    font-weight: 600;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .discovery-step.active {
    color: #5a6b80;
    font-weight: 600;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .discovery-step-dot {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid rgba(30, 42, 53, 0.15);
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    transition: all 0.3s;
  }

  .discovery-step.done .discovery-step-dot {
    background: #aece38;
    border-color: #aece38;
    color: #2d3f52;
  }

  .discovery-step.active .discovery-step-dot {
    border-color: #aece38;
    animation: registration-pulse 1s ease infinite;
  }

  @keyframes registration-pulse {
    0%,
    100% {
      box-shadow: 0 0 0 0 rgba(174, 206, 56, 0.35);
    }
    50% {
      box-shadow: 0 0 0 6px rgba(174, 206, 56, 0);
    }
  }

  .stedi-badge-footer {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    color: #6e7d8f;
    font-weight: 500;
    margin-top: 8px;
    font-family: ${REGISTRATION_FONT_BODY};
    justify-content: center;
  }

  .coverage-found-banner {
    background: linear-gradient(
      135deg,
      rgba(174, 206, 56, 0.15),
      rgba(138, 171, 21, 0.08)
    );
    border: 1.5px solid rgba(174, 206, 56, 0.4);
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    gap: 14px;
    align-items: flex-start;
    text-align: left;
  }

  .coverage-found-icon {
    font-size: 28px;
    flex-shrink: 0;
  }

  .coverage-found-title {
    font-size: 15px;
    font-weight: 700;
    color: #8aab15;
    margin-bottom: 3px;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .coverage-found-sub {
    font-size: 12px;
    color: #6e7d8f;
    line-height: 1.5;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .coverage-card {
    background: #ffffff;
    border: 1.5px solid rgba(30, 42, 53, 0.08);
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 16px;
    text-align: left;
  }

  .coverage-card-header {
    background: #5A6B80;
    color: #fff;
    padding: 12px 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .coverage-card-payer {
    font-size: 15px;
    font-weight: 700;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .coverage-card-plan {
    font-size: 11px;
    opacity: 0.7;
    margin-top: 2px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .coverage-card-badge {
    background: rgba(174, 206, 56, 0.25);
    border: 1px solid rgba(174, 206, 56, 0.5);
    border-radius: 999px;
    padding: 3px 10px;
    font-size: 10px;
    font-weight: 700;
    color: #aece38;
    flex-shrink: 0;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .coverage-fields {
    padding: 16px 18px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .coverage-field {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    gap: 12px;
  }

  .coverage-field-label {
    color: #6e7d8f;
    font-weight: 500;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .coverage-field-value {
    font-weight: 700;
    color: #5a6b80;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
    text-align: right;
  }

  .coverage-estimate {
    background: rgba(240, 175, 66, 0.08);
    border: 1.5px solid rgba(240, 175, 66, 0.25);
    border-radius: 10px;
    padding: 14px 18px;
    margin-bottom: 20px;
    text-align: left;
  }

  .coverage-estimate-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.7px;
    color: #6e7d8f;
    margin-bottom: 6px;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .coverage-estimate-amount {
    font-family: ${REGISTRATION_FONT_DISPLAY};
    font-weight: 700;
    font-size: 28px;
    font-weight: 700;
    color: #d4a017;
    line-height: 1;
  }

  .coverage-estimate-sub {
    font-size: 11px;
    color: #6e7d8f;
    margin-top: 4px;
    line-height: 1.5;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .scroll-body-rd {
    align-items: center;
  }

  .content-card-rd {
    max-width: 740px;
    width: 100%;
  }

  .content-card-scroll-rd {
    padding-top: 15px;
  }

  .rd-list-intro {
    width: 100%;
    max-width: 640px;
    margin: 0 auto 20px;
    text-align: left;
  }

  .rd-list-title {
    margin-bottom: 6px;
  }

  .rd-list-sub {
    font-size: 13px;
    color: #6e7d8f;
    line-height: 1.55;
    margin-bottom: 0;
  }

  .rd-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: 100%;
    max-width: 640px;
    margin: 0 auto;
    padding-bottom: 8px;
  }

  .rd-card {
    background: #ffffff;
    border-radius: 10px;
    border: 1.5px solid rgba(30, 42, 53, 0.07);
    box-shadow: 0 4px 32px rgba(30, 42, 53, 0.1);
    padding: 20px;
    display: flex;
    gap: 16px;
    align-items: flex-start;
    cursor: pointer;
    transition: all 0.2s;
    text-align: left;
    width: 100%;
    box-sizing: border-box;
    font-family: inherit;
  }

  .rd-card:hover {
    border-color: #aece38;
    box-shadow: 0 6px 24px rgba(175, 209, 53, 0.15);
    transform: translateY(-2px);
  }

  .rd-card-no-pref {
    border-style: dashed;
    border-color: rgba(175, 209, 53, 0.5);
    background: rgba(174, 206, 56, 0.12);
  }

  .rd-avatar {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 700;
    color: #fff;
    flex-shrink: 0;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
  }

  .rd-card-no-pref .rd-avatar {
    font-size: 22px;
  }

  .rd-info {
    flex: 1;
    min-width: 0;
  }

  .rd-name {
    font-size: 15px;
    font-weight: 700;
    color: #5a6b80;
    margin-bottom: 2px;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .rd-name-pref {
    color: #8aab15;
  }

  .rd-creds {
    font-size: 12px;
    color: #6e7d8f;
    margin-bottom: 8px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .rd-pref-desc {
    font-size: 12px;
    color: #6e7d8f;
    line-height: 1.5;
    margin: 6px 0 0;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .rd-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 8px;
  }

  .rd-tag {
    background: rgba(174, 206, 56, 0.12);
    color: #8aab15;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 999px;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .rd-states {
    font-size: 11px;
    color: #6e7d8f;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .rd-states strong {
    color: #5a6b80;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .rd-meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    flex-wrap: wrap;
    gap: 8px;
  }

  .rd-next-available,
  .rd-next-inline {
    font-size: 12px;
    color: #8aab15;
    font-weight: 600;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .rd-next-available strong,
  .rd-next-inline strong {
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .rd-about-preview {
    font-size: 12px;
    color: #6e7d8f;
    line-height: 1.55;
    margin-top: 8px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-family: ${REGISTRATION_FONT_BODY};
    white-space: pre-wrap;
  }

  .rd-arrow {
    color: #8aab15;
    font-size: 18px;
    flex-shrink: 0;
    align-self: center;
    line-height: 1;
  }

  .content-card-profile,
  .content-card-appointment {
    max-width: 640px;
    width: 100%;
    position: relative;
  }

  .calendly-widget-wrap {
    width: 100%;
    min-height: 0;
    margin-top: 8px;
    position: relative;
  }

  .calendly-booking-overlay {
    position: absolute;
    inset: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.88);
    padding: 24px;
    text-align: center;
  }

  .booking-error-modal-overlay {
    position: fixed;
    inset: 0;
    z-index: 900;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: rgba(8, 15, 28, 0.5);
  }

  .booking-error-modal-panel {
    background: #ffffff;
    border-radius: 16px;
    max-width: 420px;
    width: 100%;
    padding: 28px 24px 24px;
    box-shadow: 0 24px 60px rgba(8, 15, 28, 0.2);
    text-align: center;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .booking-error-modal-message {
    margin: 0 0 20px;
    font-size: 15px;
    line-height: 1.55;
    color: #5a6b80;
  }

  .booking-error-modal-retry {
    width: 100%;
  }

  .registration-load-retry-modal-actions {
    display: flex;
    gap: 12px;
  }

  .registration-load-retry-modal-actions .booking-error-modal-retry,
  .registration-load-retry-modal-actions .registration-load-retry-modal-cancel {
    flex: 1;
    width: auto;
  }

  .rd-profile-hero {
    background: linear-gradient(135deg, #3d5166 0%, #5a6b80 100%);
    border-radius: 10px;
    padding: 28px;
    color: #fff;
    margin-bottom: 24px;
    display: flex;
    gap: 20px;
    align-items: center;
  }

  @media (max-width: 480px) {
    .rd-profile-hero {
      flex-direction: column;
      text-align: center;
    }
  }

  .rd-profile-avatar {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: 700;
    color: #fff;
    flex-shrink: 0;
    border: 3px solid rgba(255, 255, 255, 0.2);
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
  }

  .rd-profile-name {
    font-family: ${REGISTRATION_FONT_DISPLAY};
    font-weight: 500;
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 4px;
  }

  .rd-profile-creds {
    font-size: 13px;
    opacity: 0.75;
    margin-bottom: 8px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .rd-profile-badge {
    background: rgba(174, 206, 56, 0.2);
    border: 1px solid rgba(174, 206, 56, 0.4);
    border-radius: 999px;
    padding: 4px 12px;
    font-size: 11px;
    font-weight: 600;
    color: #aece38;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .rd-stat-row {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
    margin-bottom: 20px;
    max-width: 140px;
  }

  .rd-stat {
    background: rgba(90, 107, 128, 0.06);
    border-radius: 8px;
    padding: 14px;
    text-align: center;
  }

  .rd-stat-val {
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
    font-size: 22px;
    font-weight: 700;
    color: #5a6b80;
    line-height: 1;
  }

  .rd-stat-lbl {
    font-size: 11px;
    color: #6e7d8f;
    margin-top: 4px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .rd-detail-section {
    margin-bottom: 20px;
    text-align: left;
  }

  .rd-detail-section-last {
    margin-bottom: 28px;
  }

  .rd-detail-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: #6e7d8f;
    margin-bottom: 8px;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .rd-detail-text {
    font-size: 14px;
    color: #2d3f52;
    line-height: 1.65;
    font-family: ${REGISTRATION_FONT_BODY};
    white-space: pre-wrap;
  }

  .rd-detail-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .rd-detail-categories {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 24px;
  }

  .rd-detail-category {
    color: #8aab15;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.5;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .rd-detail-chip {
    background: rgba(174, 206, 56, 0.12);
    color: #8aab15;
    font-size: 12px;
    font-weight: 600;
    padding: 5px 12px;
    border-radius: 999px;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .rd-detail-chip-state {
    background: rgba(240, 175, 66, 0.12);
    color: #8aab15;
  }

  .content-card-profile .btn-ghost {
    margin-top: 10px;
  }

  .appointment-week-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    gap: 12px;
    flex-wrap: wrap;
  }

  .appointment-week-nav {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }

  .appointment-week-nav-btn {
    min-height: 34px;
    border-radius: 999px;
    border: 1.5px solid rgba(90, 107, 128, 0.28);
    background: #fff;
    color: #2d3f52;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.2;
    cursor: pointer;
    padding: 8px 12px;
    font-family: ${REGISTRATION_FONT_BODY};
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

    .appointment-week-nav-arrow {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      line-height: 1;
      flex-shrink: 0;
    }

    &:hover:not(:disabled) {
      background: #eef3e0;
      border-color: rgba(138, 171, 21, 0.45);
      color: #5a6b10;
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  .appointment-week-label {
    font-size: 13px;
    font-weight: 600;
    color: #5a6b80;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .appointment-week-note {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: auto;
    gap: 8px;
    font-size: 11px;
    color: #6e7d8f;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .appointment-week-note-divider {
    color: rgba(30, 42, 53, 0.28);
    font-weight: 600;
    line-height: 1;
  }

  .appointment-week-body {
    position: relative;
    min-height: 160px;
  }

  .appointment-week-loading-overlay {
    position: absolute;
    inset: 0;
    z-index: 5;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 14px;
    background: rgba(255, 255, 255, 0.88);
    border-radius: 16px;
    padding: 24px;
    text-align: center;
  }

  .appointment-week-grid {
    --appointment-day-count: 5;
  }

  .week-header {
    display: grid;
    grid-template-columns: repeat(var(--appointment-day-count, 5), minmax(0, 1fr));
    gap: 8px;
    margin-bottom: 8px;
  }

  .day-label {
    text-align: center;
    font-size: 11px;
    font-weight: 700;
    color: #6e7d8f;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .day-date {
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    color: #5a6b80;
    margin-bottom: 4px;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .appointment-period {
    margin-bottom: 4px;
  }

  .appointment-period + .appointment-period .slot-time-label {
    margin-top: 14px;
  }

  .slot-time-label {
    font-size: 10px;
    font-weight: 500;
    color: #6e7d8f;
    margin-bottom: 8px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .slots-grid {
    display: grid;
    grid-template-columns: repeat(var(--appointment-day-count, 5), minmax(0, 1fr));
    gap: 8px;
    margin-bottom: 8px;
  }

  .slot {
    border: 1.5px solid rgba(30, 42, 53, 0.12);
    border-radius: 8px;
    padding: 9px 4px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 12px;
    font-weight: 600;
    color: #5a6b80;
    background: #ffffff;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
    box-sizing: border-box;
    width: 100%;
  }

  button.slot {
    appearance: none;
  }

  .slot:hover:not(.slot-booked):not(.slot-selected) {
    border-color: #aece38;
    background: rgba(174, 206, 56, 0.12);
  }

  .slot.slot-selected {
    border-color: #aece38;
    background: #aece38;
    color: #5a6b80;
  }

  .slot.slot-booked {
    opacity: 0.38;
    cursor: not-allowed;
    background: rgba(30, 42, 53, 0.04);
  }

  .selected-slot-preview {
    background: rgba(174, 206, 56, 0.12);
    border: 1.5px solid rgba(175, 209, 53, 0.35);
    border-radius: 8px;
    padding: 14px 18px;
    display: none;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
    text-align: left;
  }

  .selected-slot-preview.show {
    display: flex;
  }

  .slot-preview-icon {
    font-size: 20px;
  }

  .slot-preview-text {
    font-size: 14px;
    font-weight: 600;
    color: #5a6b80;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .slot-preview-sub {
    font-size: 12px;
    color: #6e7d8f;
    margin-top: 2px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .slot-legend {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }

  .slot-legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    color: #6e7d8f;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .slot-legend-swatch {
    width: 12px;
    height: 12px;
    border-radius: 2px;
    flex-shrink: 0;
  }

  .slot-legend-available {
    background: #eeeeee;
    opacity: 0.7;
  }

  .slot-legend-booked {
    background: #dbdcd7;
  }

  .slot-legend-selected {
    background: #aece38;
  }

  .appointment-book-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  .confirm-hero {
    text-align: center;
    padding: 28px 0 20px;
  }

  .confirm-check {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: #aece38;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 18px;
  }

  .confirm-title {
    font-family: ${REGISTRATION_FONT_DISPLAY};
    font-weight: 500;
    font-size: 24px;
    color: #5a6b80;
    margin: 0 0 8px;
    line-height: 1.2;
  }

  .confirm-sub {
    font-size: 14px;
    color: #6e7d8f;
    line-height: 1.6;
    max-width: 320px;
    margin: 0 auto;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .content-card-no-rd {
    display: flex;
    flex-direction: column;
    min-height: min(480px, calc(100dvh - clamp(56px, 5vw + 36px, 88px)));
  }

  .content-card-scroll-no-rd {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .no-rd-hero {
    text-align: center;
    width: 100%;
    padding: 0;
  }

  .no-rd-icon {
    font-size: 48px;
    line-height: 1;
    margin-bottom: 16px;
  }

  .no-rd-message {
    font-family: ${REGISTRATION_FONT_DISPLAY};
    font-size: 22px;
    font-weight: 500;
    color: #5a6b80;
    line-height: 1.45;
    max-width: 420px;
    margin: 0 auto;

    @media (min-width: 600px) {
      font-size: 26px;
    }
  }

  .no-rd-reference {
    margin: 20px auto 0;
    font-size: 13px;
    color: #6e7d8f;
    font-family: ${REGISTRATION_FONT_BODY};

    strong {
      color: #5a6b80;
      font-weight: 700;
    }
  }

  .no-rd-actions {
    margin-top: 28px;
    display: flex;
    justify-content: center;
  }

  .appt-detail {
    background: rgba(90, 107, 128, 0.06);
    border-radius: 8px;
    padding: 18px 20px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .appt-row {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .appt-icon {
    font-size: 18px;
    width: 28px;
    flex-shrink: 0;
    text-align: center;
  }

  .appt-label {
    font-size: 11px;
    color: #6e7d8f;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .appt-value {
    font-size: 14px;
    font-weight: 600;
    color: #5a6b80;
    margin-top: 1px;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .appt-id {
    text-align: center;
    font-size: 12px;
    color: #6e7d8f;
    margin-bottom: 24px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .appt-id strong {
    color: #5a6b80;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .confirm-action-box {
    background: rgba(240, 175, 66, 0.09);
    border: 1.5px solid rgba(240, 175, 66, 0.35);
    border-radius: 8px;
    padding: 16px 18px;
    margin-bottom: 20px;
    display: flex;
    gap: 12px;
    align-items: flex-start;
  }

  .confirm-action-icon {
    font-size: 20px;
    flex-shrink: 0;
  }

  .confirm-action-title {
    font-size: 13px;
    font-weight: 700;
    color: #2d3f52;
    margin-bottom: 4px;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .confirm-action-text {
    font-size: 13px;
    color: #6e7d8f;
    line-height: 1.6;
    margin: 0;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .confirm-action-text strong {
    color: #2d3f52;
  }

  .confirm-calendar-wrap {
    position: relative;
    margin-top: 10px;
    width: 100%;
  }

  .confirm-calendar-menu {
    position: absolute;
    bottom: calc(100% + 8px);
    left: 0;
    right: 0;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(45, 63, 82, 0.12);
    overflow: hidden;
    z-index: 10;
  }

  .confirm-calendar-menu-item {
    display: block;
    width: 100%;
    padding: 12px 16px;
    text-align: left;
    background: none;
    border: none;
    color: #2d3f52;
    font-size: 14px;
    font-family: ${REGISTRATION_FONT_BODY};
    cursor: pointer;
  }

  .confirm-calendar-menu-item:hover,
  .confirm-calendar-menu-item:focus {
    background: #f4f7fa;
    outline: none;
  }

  .confirm-calendar-menu-item + .confirm-calendar-menu-item {
    border-top: 1px solid #eef2f6;
  }

  .confirm-calendar-btn {
    width: 100%;
  }

  .app-dl-hero {
    text-align: center;
    padding: 32px 0 24px;
  }

  .app-dl-icon {
    width: 88px;
    height: 88px;
    border-radius: 22px;
    background: linear-gradient(135deg, #aece38, #8aab15);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    box-shadow: 0 8px 24px rgba(175, 209, 53, 0.3);
  }

  .app-dl-title {
    font-family: ${REGISTRATION_FONT_DISPLAY};
    font-weight: 500;
    font-size: 24px;
    color: #5a6b80;
    margin: 0 0 10px;
    line-height: 1.2;
  }

  .app-dl-sub {
    font-size: 14px;
    color: #6e7d8f;
    line-height: 1.65;
    max-width: 340px;
    margin: 0 auto 28px;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .app-feature-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 24px;
  }

  .app-feature-item {
    display: flex;
    gap: 12px;
    align-items: center;
    padding: 12px 14px;
    background: rgba(90, 107, 128, 0.05);
    border-radius: 10px;
  }

  .app-feature-icon {
    font-size: 18px;
    flex-shrink: 0;
  }

  .app-feature-title {
    font-size: 13px;
    font-weight: 600;
    color: #5a6b80;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
  }

  .app-feature-desc {
    font-size: 12px;
    color: #6e7d8f;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .app-dl-alert {
    background: rgba(240, 175, 66, 0.09);
    border: 1.5px solid rgba(240, 175, 66, 0.3);
    border-radius: 8px;
    padding: 13px 16px;
    margin-bottom: 20px;
    font-size: 13px;
    color: #2d3f52;
    line-height: 1.55;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .store-btns.app-icon {
    display: flex;
    gap: 10px;
    justify-content: center;
    flex-wrap: wrap;
    margin: 0 auto 16px;
  }

  .app-dl-or {
    text-align: center;
    font-size: 12px;
    color: #6e7d8f;
    margin: 8px 0;
    font-family: ${REGISTRATION_FONT_BODY};
  }

  .app-dl-already-wrap {
    text-align: center;
  }

  .app-already-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 13px;
    color: #5a6b80;
    font-weight: 600;
    font-family: ${REGISTRATION_FONT_BODY};
    font-weight: 700;
    text-decoration: underline;
    text-underline-offset: 3px;
    padding: 0;
  }

  .app-dl-done-wrap {
    text-align: center;
    padding-top: 4px;
  }

  .app-dl-done-btn {
    min-width: 220px;
  }

  .content-card-all-set {
    max-width: 640px;
    width: 100%;
  }

  .content-card-scroll-all-set {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .all-set-hero {
    text-align: center;
    padding: 16px 0 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    width: 100%;
    box-sizing: border-box;
  }

  .all-set-gif-wrap {
    width: min(420px, 88vw);
    flex-shrink: 0;
    line-height: 0;
  }

  .all-set-gif {
    width: 100%;
    height: auto;
    aspect-ratio: 1620 / 911;
    display: block;
    object-fit: contain;
    object-position: center;
  }

  .all-set-title {
    font-family: ${REGISTRATION_FONT_DISPLAY};
    font-size: 22px;
    font-weight: 500;
    color: #5a6b80;
    line-height: 1.4;
    max-width: 320px;
    margin: 0;
  }
`;

export default RegistrationSetupWrapper;
